import {
  FETCHING_SEEK_ANSWER, FETCHING_SEEK_ANSWER_SUCCEEDED, FETCHING_SEEK_ANSWER_FAILED,
  UPDATING_SEEK_HELPFUL, UPDATING_SEEK_HELPFUL_SUCCEEDED, UPDATING_SEEK_HELPFUL_FAILED,
  INVALIDATE_SEEK_SESSION, FETCHING_SEEK_LIMIT, FETCHING_SEEK_LIMIT_SUCCEEDED, FETCHING_SEEK_LIMIT_FAILED,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE, FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED, FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED,
  FETCH_SEEK_PROMPTS, FETCHING_SEEK_PROMPTS_SUCCEEDED, FETCHING_SEEK_PROMPTS_FAILED
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import buildUrl from 'build-url';
import { call, put, takeEvery } from 'redux-saga/effects';

import _ from 'lodash';

const apiUrl = process.env.REACT_APP_API_URL;
const SEEK_URL = `${apiUrl}/api/2.0/seek`;

//Fetch Seek Answer
export const fetchSeekAnswer = createAction(FETCHING_SEEK_ANSWER, (session, question, callback) => {
  return { session, question };
});

const fetchSeekAnswerSucceeded = createAction(FETCHING_SEEK_ANSWER_SUCCEEDED, (response, session) => {
  return { response, session };
});

const fetchSeekAnswerFailed = createAction(FETCHING_SEEK_ANSWER_FAILED, (session, question, error) => {
  return { session, question, error };
});


function* fetchSeekAnswerSaga(action) {

  const { session, question, callback } = action.payload;

  const fetchSeekAnswerAPI = () => {

    const data = {
      question: question,
      session: session,
      assetId: ""
    }

    return axios({
      method: 'POST',
      url: SEEK_URL,
      data: data
    }).then(response => response.data);


  }

  try {
    const response = yield call(fetchSeekAnswerAPI);
    yield put(fetchSeekAnswerSucceeded(response, session));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(fetchSeekAnswerFailed({ session, question, error }));
  }
}

//Update Seek Helpful
export const updateSeekHelpful = createAction(UPDATING_SEEK_HELPFUL, (chatId, isHelpful, callback) => {
  return { chatId, isHelpful, callback };
});

const updatingSeekHelpfulSucceeded = createAction(UPDATING_SEEK_HELPFUL_SUCCEEDED, (response, chatId) => {
  return { response, chatId };
});

const updatingSeekHelpfulFailed = createAction(UPDATING_SEEK_HELPFUL_FAILED, (chatId, error) => {
  return { chatId, error };
});


function* updateSeekHelpfulSaga(action) {

  const { chatId, isHelpful, callback } = action.payload;

  const updateSeekHelpfulAPI = () => {

    const data = {
      isHelpful: isHelpful
    }

    let url = buildUrl(SEEK_URL, {
      path: `/chats/${chatId}/feedback`,
    });

    return axios({
      method: 'PUT',
      url: url,
      params: data
    }).then(response => response.data);


  }

  try {
    const response = yield call(updateSeekHelpfulAPI);
    yield put(updatingSeekHelpfulSucceeded(response, chatId));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(updatingSeekHelpfulFailed({ chatId, error }));
  }
}
// seek email 

export const fetchEmailForSeekResponse = createAction(FETCHING_EMAIL_FOR_SEEK_RESPONSE, (id , chatId) => {
  return { id, chatId };
});

const fetchingEmailForSeekResponseSucceeded = createAction(FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED, (response) => {
  return {response };
});

const fetchingEmailForSeekResponseFailed = createAction(FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED, (error) => {
  return {error };
});


function* fetchEmailForSeekResponseSaga(action) {
  const { id, chatId } = action.payload;

  const fetchEmailForSeekAPI = () => {

    let url = buildUrl(SEEK_URL, {
      path: `sessions/${chatId}/chats/${id}/email`,
    });


    return axios({
      method: 'GET',
      url: url,
    }).then(response => response.data)
      .catch(error => {
        console.error("API call failed:", error);
        throw error;
      });
  }

  try {
    const response = yield call(fetchEmailForSeekAPI);

    yield put(fetchingEmailForSeekResponseSucceeded(response));
  } catch (error) {
    yield put(fetchingEmailForSeekResponseFailed({ error }));
    console.error("Email Fetch Failed:", error);
  }
}


//Invalidate Seek Session
export const invalidateSeekSession = createAction(INVALIDATE_SEEK_SESSION, () => {
  return;
});

//Update Seek Helpful
export const fetchSeekLimit = createAction(FETCHING_SEEK_LIMIT, () => {
  return;
});

const fetchSeekLimitSucceeded = createAction(FETCHING_SEEK_LIMIT_SUCCEEDED, (response) => {
  return response;
});

const fetchSeekLimitFailed = createAction(FETCHING_SEEK_LIMIT_FAILED, () => {
  return {};
});


function* fetchSeekLimitSaga() {

  const fetchSeekLimitAPI = () => {

    let url = buildUrl(SEEK_URL, {
      path: `/limit`,
    })

    return axios({
      method: "GET",
      url: url
    }).then(response => response.data);


  }

  try {
    const response = yield call(fetchSeekLimitAPI);
    yield put(fetchSeekLimitSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchSeekLimitFailed());
  }
}


//Fetch Seek Prompts
export const fetchSeekPrompts = createAction(FETCH_SEEK_PROMPTS);

const fetchingSeekPromptsSucceeded = createAction(
  FETCHING_SEEK_PROMPTS_SUCCEEDED
);

const fetchingSeekPromptsFailed = createAction(
  FETCHING_SEEK_PROMPTS_FAILED
);

function* fetchSeekPromptsSaga() {
  const fetchSeekPromptsApi = () => {
    return axios({
      method: "GET",
      url: `${SEEK_URL}/suggestions`,
    }).then((response) => {
      // Ensure we return an array, even if the API returns an object
      const data = response.data;
      return Array.isArray(data) ? data : (data.suggestions || data.prompts || []);
    });
  };

  try {
    const response = yield call(fetchSeekPromptsApi);
    yield put(fetchingSeekPromptsSucceeded(response));
  } catch (error) {
    yield put(fetchingSeekPromptsFailed(error));
  }
}

export default function* seekSaga() {
  yield takeEvery(FETCHING_SEEK_ANSWER, fetchSeekAnswerSaga);
  yield takeEvery(UPDATING_SEEK_HELPFUL, updateSeekHelpfulSaga);
  yield takeEvery(FETCHING_SEEK_LIMIT, fetchSeekLimitSaga);
  yield takeEvery(FETCHING_EMAIL_FOR_SEEK_RESPONSE, fetchEmailForSeekResponseSaga);
  yield takeEvery(FETCH_SEEK_PROMPTS, fetchSeekPromptsSaga);
};
